module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0MyA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjA2MjEgMjIuMjQ0MUw0Mi41MDAyIDMuNTU1MUwzOS42ODc3IDAuNzQyNTk2TDIxLjIxODQgMTkuNDAwM0wzLjYyNDYyIDAuODM3ODMzTDAuODEyMTI0IDMuNjUwMzNMMTguMzc0NiAyMi4yNDQxTDAuNTQ4MzQgNDAuMzM2TDMuMzYwODQgNDMuMTQ4NUwyMS4yMTg0IDI1LjA4NzhMMzkuNjM5OSA0My40MjAyTDQyLjQ1MjQgNDAuNjA3N0wyNC4wNjIxIDIyLjI0NDFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/x.svg
// module id = +08w
// module chunks = 0